import React from 'react';
import { useOptimisedImages } from '@navi-toolbox/hooks';
import { Props } from './service-card.types';
import { card, cardTitle, cardDesc, cardText } from './service-card.styles';

export const ServiceCard = ({ size, text, title, image }: Props) => {
  const rest = {
    w: '112',
    h: '80',
  };
  const promoPhotos = useOptimisedImages({
    src: image,
    sizes: {
      rest,
    },
  });

  return (
    <div className={card} data-size={size}>
      <div className="imgWrap">
        <picture>
          <source srcSet={`${promoPhotos.rest?.xx} 2x, ${promoPhotos.rest?.x} 1x`} />
          <img
            alt={title}
            src={promoPhotos.rest?.x ?? undefined}
            width={rest.w}
            height={rest.h}
            srcSet={`${promoPhotos.rest?.xx} 2x, ${promoPhotos.rest?.x} 1x`}
          />
        </picture>
      </div>
      <div className={cardText}>
        <div className={cardTitle} data-size={size} title={text}>
          {title}
        </div>
        <div className={cardDesc} data-size={size} title={text}>
          {text}
        </div>
      </div>
    </div>
  );
};
